import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { stateCollegeConfig } from "./data";

export default function StateCollegePage() {
  return <CityPageTemplate config={stateCollegeConfig} />;
}